__turbopack_context__.v({
  "buttonContainer": "TermDepositProductSelection-module-scss-module__13AwTa__buttonContainer",
  "buttonContainerMid": "TermDepositProductSelection-module-scss-module__13AwTa__buttonContainerMid",
  "buttonGroup": "TermDepositProductSelection-module-scss-module__13AwTa__buttonGroup",
  "buttonSubtitle": "TermDepositProductSelection-module-scss-module__13AwTa__buttonSubtitle",
});
